import { Toaster as Sonner } from "sonner";
import { useTranslation } from "react-i18next";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { i18n } = useTranslation();
  const isAr = i18n.language === "ar";
  const position = isAr ? "bottom-right" : "bottom-left";

  return (
    <Sonner
      position={position}
      richColors
      closeButton
      dir={isAr ? "rtl" : "ltr"}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-surface-container-lowest group-[.toaster]:text-primary group-[.toaster]:border-outline-variant/50 group-[.toaster]:rounded-xl group-[.toaster]:luxury-shadow group-[.toaster]:font-body-md",
          title: "font-semibold tracking-wide",
          description: "group-[.toast]:text-on-surface-variant",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
